import React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
// import { useNavigate, useHistory, useLocation } from "react-router-dom";
import "./NestedNavigation.css";

function NestedNavigation() {
  const handleAboutNav = () => {
    window.location.href = "#about";
  };
  const handleSkillsNav = () => {
    window.location.href = "#skills";
  };
  const handleRecommendationsNav = () => {
    window.location.href = "#recommendations";
  };

  return (
    <ButtonGroup
      className="nav_container"
      variant="contained"
      aria-label="outlined primary button group"
    >
      <Button onClick={handleAboutNav}>About</Button>
      <Button onClick={handleSkillsNav}>Skils</Button>
      <Button onClick={handleRecommendationsNav}>Recommendations</Button>
    </ButtonGroup>
  );
}

export default NestedNavigation;
